import React, { useEffect, useRef, useState } from "react";
import logo from "../Images/Group 1171279193 (1).png";
import logo2 from "../Images/Group 1171279193.png";
import logo3 from "../Images/darklogo.png";
import logown from "../Images/logown.png";
import phone from "../Images/Group.png";
import whatsapp from "../Images/whatsapp.png";
import menu from "../Images/Vector (16).png";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import Sidebar2 from "./Sidebar2";
import { openWhatsAppLink } from "../Component/OpenWhatsApp";
import HomeService from "../Services/HomeService";
const Header2 = () => {
  const [show, setShow] = useState(false);
  const [navActive, setnavActive] = useState(false);
  const [citiesWithCityDetails, setCitiesWithCityDetails] = useState([]);
  const [isCitySubMenuOpen, setIsCitySubMenuOpen] = useState(false);
  const location = useLocation();
  const citySubmenuRef = useRef();

  const sidebarfunc = () => {
    setShow(true);
  };
  const sidebarfunc2 = () => {
    setShow(false);
  };

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsLoggedIn(!!token);
  }, []);

  const handleAuthRedirect = () => {
    navigate("/profile");
  };

  const NavScroll = () => {
    if (window.scrollY > 10) {
      setnavActive(true);
    } else {
      setnavActive(false);
    }
  };

  const fetchCitiesWithCityDetails = async () => {
    try {
      const res = await HomeService.getCitiesWithCityDetails();
      console.log("city details header", res);
      if (res?.status) {
        setCitiesWithCityDetails(res?.data);
      } else {
        console.log(res);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (location.pathname != "/") {
      setnavActive(true);
    }
    fetchCitiesWithCityDetails();
  }, []);

  window.addEventListener("scroll", () => {
    if (location.pathname == "/") {
      NavScroll();
    }
  });

  // Close everything if clicked outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        citySubmenuRef.current &&
        !citySubmenuRef.current.contains(e.target)
      ) {
        setIsCitySubMenuOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  return (
    <>
      <div
        className={
          location.pathname != "/" ? "header_not_fixed" : "header_main78995"
        }
        // style={navActive ? { background: "#fff" } : {}}
        // style={{ background: "#fff" }}
      >
        <div className="header_2_main_wrapper">
          <div className="header_logo_main_div" onClick={() => navigate("/")}>
            <img src={logo2} className="light-logo" alt="Logo" />
            <img src={logown} className="dark-logo" alt="Logo" />
          </div>
          <div className="header_links_wrapper_div">
            <NavLink
              to="/"
              end
              className={({ isActive }) =>
                isActive ? "header_link active" : "header_link"
              }
            >
              Home
            </NavLink>

            <NavLink
              to="/propertylist"
              className={({ isActive }) =>
                isActive ? "header_link active" : "header_link"
              }
            >
              Properties
            </NavLink>

            <NavLink
              to="/communitylist"
              className={({ isActive }) =>
                isActive ? "header_link active" : "header_link"
              }
            >
              Community
            </NavLink>

            <NavLink
              to="/profile"
              className={({ isActive }) =>
                isActive ? "header_link active" : "header_link"
              }
            >
              Profile
            </NavLink>

            <NavLink
              to="/aboutus"
              className={({ isActive }) =>
                isActive ? "header_link active" : "header_link"
              }
            >
              About
            </NavLink>

            <NavLink
              to="/blog"
              className={({ isActive }) =>
                isActive ? "header_link active" : "header_link"
              }
            >
              Blog
            </NavLink>

            <NavLink
              to="/pricingplan"
              className={({ isActive }) =>
                isActive ? "header_link active" : "header_link"
              }
            >
              Price
            </NavLink>

            <NavLink
              to="/career"
              className={({ isActive }) =>
                isActive ? "header_link active" : "header_link"
              }
            >
              Careers
            </NavLink>

            <div
              style={{ cursor: "pointer" }}
              ref={citySubmenuRef}
              className={`header_link ${isCitySubMenuOpen ? "" : ""}`}
              onClick={() => {
                setIsCitySubMenuOpen(!isCitySubMenuOpen);
              }}
            >
              Cities
            </div>
            {/* <NavLink
                    ref={citySubmenuRef}
                    className="header_link"
                    onClick={() => {
                      setIsCitySubMenuOpen(!isCitySubMenuOpen);
                    }}
                  >
                    Cities
                  </NavLink> */}

            {/* hide for some reason */}
            {0 === 1 && (
              <>
                <NavLink
                  to={"/"}
                  className="header_link"
                  // style={navActive ? { color: "#000" } : {}}
                  style={{ color: "#000" }}
                >
                  Home
                </NavLink>
                <NavLink
                  className="header_link"
                  to={"/propertylist"}
                  // style={navActive ? { color: "#000" } : {}}
                  style={{ color: "#000" }}
                >
                  Properties
                </NavLink>
                <NavLink
                  to={"/communitylist"}
                  className="header_link"
                  // style={navActive ? { color: "#000" } : {}}
                  style={{ color: "#000" }}
                >
                  Community
                </NavLink>
                <NavLink
                  className="header_link"
                  to={"/profile"}
                  // style={navActive ? { color: "#000" } : {}}
                  style={{ color: "#000" }}
                >
                  Profile
                </NavLink>
                <NavLink
                  to={"/aboutus"}
                  className="header_link"
                  // style={navActive ? { color: "#000" } : {}}
                  style={{ color: "#000" }}
                >
                  About
                </NavLink>
                <NavLink
                  className="header_link"
                  to={"/blog"}
                  // style={navActive ? { color: "#000" } : {}}
                  style={{ color: "#000" }}
                >
                  Blog
                </NavLink>
                <NavLink
                  className="header_link"
                  to={"/pricingplan"}
                  // style={navActive ? { color: "#000" } : {}}
                  style={{ color: "#000" }}
                >
                  Price
                </NavLink>
                <NavLink
                  className="header_link"
                  to={"/career"}
                  // style={navActive ? { color: "#000" } : {}}
                  style={{ color: "#000" }}
                >
                  Careers
                </NavLink>
                <NavLink
                  ref={citySubmenuRef}
                  className="header_link"
                  // to={"/career"}
                  // style={navActive ? { color: "#000" } : {}}
                  style={{ color: "#000" }}
                  onClick={() => {
                    setIsCitySubMenuOpen(!isCitySubMenuOpen);
                  }}
                >
                  Cities
                </NavLink>
              </>
            )}

            {/* {isCitySubMenuOpen && (
              <div style={{ position: "relative" }}>
                <div
                  style={{
                   
                    minWidth: "150px",
                    backgroundColor: "#003466",
                    position: "absolute",
                    top: "25px",
                    right: "-45px",
                    borderRadius: "5px",
                    padding: "10px 4px",
                    zIndex: "99999999999",
                    color: "#fff",
                  }}
                >
                  {citiesWithCityDetails?.length === 0 ? (
                    <p
                      style={{
                        margin: "5px 5px",
                        fontWeight: "600",
                       
                      }}
                    >
                      No City Found
                    </p>
                  ) : (
                    citiesWithCityDetails?.map((e, i) => {
                      return (
                        <p
                          style={{
                            margin: "5px 5px",
                            fontWeight: "500",
                            cursor: "pointer",
                            fontSize: "15px",
                          }}
                          onClick={() => {
                            const city = e?.cityData?.name
                              ?.trim()
                              .replace(/\s+/g, "-");
                            navigate(`/${city}`, {
                              state: { id: e?.cityData?._id },
                            });
                            setIsCitySubMenuOpen(false);
                          }}
                        >
                          {e?.cityData?.name}
                          <hr style={{ borderTop: "2px solid white" }} />
                        </p>
                      );
                    })
                  )}
                </div>
              </div>
            )} */}

            {isCitySubMenuOpen && (
  <div className="city_dropdown_wrapper">
    <div className="city_dropdown_menu">
      {citiesWithCityDetails?.length === 0 ? (
        <p className="city_dropdown_empty">
          No City Found
        </p>
      ) : (
        citiesWithCityDetails?.map((e, i) => (
          <p
            key={i}
            className="city_dropdown_item"
            onClick={() => {
              const city = e?.cityData?.name
                ?.trim()
                .replace(/\s+/g, "-");

              navigate(`/${city}`, {
                state: { id: e?.cityData?._id },
              });

              setIsCitySubMenuOpen(false);
            }}
          >
            {e?.cityData?.name}
            <hr className="city_dropdown_hr" />
          </p>
        ))
      )}
    </div>
  </div>
)}
            {/* <NavLink className='header_link' to={'/career'}>Sign In</NavLink>
            <NavLink className='header_link' to={'/career'}>Sign Up</NavLink> */}
          </div>

          <div className="header_call_wrapper_div">
            {/* <a href="tel:91987654321" style={{ textDecoration: "none" }}> */}
            <a
              href="tel:8009903561"
              style={{ textDecoration: "none", display: "none" }}
            >
              <div className="call_us_div5">
                <img src={phone} alt="Phone Icon" />
                <p>Call Us</p>
              </div>
            </a>

            <div
              className="chat_on_whatsapp_wrapper_div d-none"
              style={{ cursor: "pointer" }}
              onClick={(e) =>
                // openWhatsAppLink(e, "919876543210", "I am interested")
                openWhatsAppLink(e, "918009903561", "I am interested")
              }
            >
              <img src={whatsapp} alt="WhatsApp Icon" />
              <p>Chat On Whatsapp</p>
            </div>

            {/* Conditional Rendering */}
            {isLoggedIn ? (
              <div onClick={sidebarfunc} className="menu_bar_wrapper_div">
                <img src={menu} alt="Menu Icon" />
              </div>
            ) : (
              <button className="auth_button" onClick={handleAuthRedirect}>
                Sign Up / Log In
              </button>
            )}
          </div>
        </div>
      </div>

      {show && <Sidebar2 sidebarfunc2={sidebarfunc2} />}
    </>
  );
};

export default Header2;
